// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rlQ_","textarea":"styles_textarea__CLHvx"};